import React, { useState } from "react";
import styled from "styled-components";
import "react-dates/initialize";
import {
  DateRangePicker,
  isInclusivelyBeforeDay,
  SingleDatePicker,
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { StyledText } from "./StyledComponents";

const Wrap = styled.div(
  (props) => `
  position:relative;
  .DateRangePicker_picker {
    z-index: 3;
    left: -10px !important;
  }
  .CalendarDay__selected {
    background: ${props.theme.primary} !important;
    border: 1px solid ${props.theme.primary};
  }
  .DateInput_input__focused {
   border-bottom: 2px solid ${props.theme.primary};
  }
  >div>div>div{
    display: inline-flex;
    align-items: center;
    min-width: ${props.minWidth || 100}px;
    max-height: ${props.maxHeight || 100}px;
    height:  ${props.height || 40}px;
  }
  .DateInput_input {
    padding: 8px 11px 6px;
    font-size: 15px !important;
    color: black;
    line-height: 17px !important;
    font-weight: normal !important;
    border-bottom: none !important;
  }
  .SingleDatePicker.SingleDatePicker_1>div>div>div{
    z-index:3;
    border-radius: 4px !important;
    width: 100% !important;
  }
  .DateInput_1 {
    z-index: 1 !important;
  }
  .DateInput,
  .SingleDatePicker {
    width: 100% !important;
  }
  .SingleDatePickerInput__withBorder {
    border-radius: 4px !important;
    width: 100% !important;
    border: 1px solid lightgrey;
  }
  .CalendarMonthGrid,  .CalendarMonth_caption {
    font-size: 14px !important;
    font-weight: normal !important;
  }
`
);


const returnYears = () => {
    let years = [];
    for (let i = moment().year() - 21; i <= moment().year() + 29; i++) {
      years.push(<option value={i}>{i}</option>);
    }
    return years;
  };


  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div>
        <select
          style={{
            padding: 2,
            marginRight: 5,
            borderColor: '#e4e7e7'
          }}
          value={month.month()}
          onChange={(e) => onMonthSelect(month, e.target.value)}
        >
          {moment.months().map((label, value) => (
            <option value={value}>{label}</option>
          ))}
        </select>
      </div>
      <div>
        <select
          style={{
            padding: 2,
            marginRight: 5,
            borderColor: '#e4e7e7'
          }}
          value={month.year()}
          onChange={(e) => onYearSelect(month, e.target.value)}
        >
          {returnYears()}
        </select>
      </div>
    </div>
  );

function DatePicker({
  type,
  label,
  numberOfMonths = 1,
  showDateLabel,
  ...props
}) {
  const [focusedInput, setFocusedInput] = useState(false);
  return (
    <Wrap {...props}>
      {label ? (
        <StyledText
          color="#565656"
          style={{
            backgroundColor: "#fff",
            fontSize: 13,
            display: "inline-block",
            zIndex: "2",
            position: "absolute",
            top: -10,
            left: 10,
            background: "#ffffff",
            textTransform: "capitalize",
            padding: 2,
          }}
        >
          {label}
        </StyledText>
      ) : null}
      {type === "single" ? (
        <SingleDatePicker
          hideKeyboardShortcutsPanel
          numberOfMonths={numberOfMonths}
          onYearSelect={props.yearChange}
          id="your_unique_id"
          displayFormat="DD MMM YYYY"
          showDefaultInputIcon={true}
          inputIconPosition="after"
          small
          // isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
          {...props}
          readOnly={true}
          renderMonthElement={renderMonthElement}
          focused={focusedInput}
          onFocusChange={({ focused }) => setFocusedInput(focused)}
        />
      ) : (
        <DateRangePicker
          readOnly={true}
          hideKeyboardShortcutsPanel
          isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
          {...props}
          endDatePlaceholderText={"End Date"}
          startDatePlaceholderText={"Start Date"}
          focused={focusedInput}
          onFocusChange={({ focused }) => setFocusedInput(focused)}
        />
      )}
    </Wrap>
  );
}
export default DatePicker;
